export default {
  "languagesText": {
    "en": "Languages"
  },
  "themeText": {
    "en": "Theme"
  },
  "versionsText": {
    "en": "Versions"
  },
  "menuTitle": {
    "en": "Menu"
  },
  "outlineTitle": {
    "en": "ON THIS PAGE"
  },
  "scrollToTopText": {
    "en": "Back to top"
  },
  "lastUpdatedText": {
    "en": "Last Updated"
  },
  "prevPageText": {
    "en": "Previous page"
  },
  "nextPageText": {
    "en": "Next page"
  },
  "sourceCodeText": {
    "en": "Source Code"
  },
  "searchPlaceholderText": {
    "en": "Search"
  },
  "searchPanelCancelText": {
    "en": "Cancel"
  },
  "searchNoResultsText": {
    "en": "No matching results"
  },
  "searchSuggestedQueryText": {
    "en": "Try searching for different keywords"
  },
  "overview.filterNameText": {
    "en": "Filter"
  },
  "overview.filterPlaceholderText": {
    "en": "Search API"
  },
  "overview.filterNoResultText": {
    "en": "No matching API found"
  },
  "openInText": {
    "en": "Open in {{name}}"
  },
  "copyMarkdownText": {
    "en": "Copy Markdown"
  },
  "copyMarkdownLinkText": {
    "en": "Copy Markdown link"
  },
  "editLinkText": {
    "en": "Edit this page"
  },
  "codeButtonGroupCopyButtonText": {
    "en": "Copy code"
  },
  "notFoundText": {
    "en": "PAGE NOT FOUND"
  },
  "takeMeHomeText": {
    "en": "Take me home"
  }
}